import { createContext } from '@wordpress/element';
export const RadioGroupContext = createContext({
  store: undefined,
  disabled: undefined
});
RadioGroupContext.displayName = 'RadioGroupContext';